import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
@Component({
    selector: 'app-cs-ag-grid-custom-user-renderer',
    template: `
    <ng-container *ngIf="params.data.assignees?.length; else noData">
      <ng-container *ngIf="params.data.assignees.length > 1; else showNames">
        <app-user-icon-list
          [usersList]="params.data.assignees.length"
          [imageList]="params.data.assignees"
          [isGridCell]="params.eGridCell ? true : false"
          [useInitialsFallback]="true">
        </app-user-icon-list>
      </ng-container>

      <ng-template #showNames>
        <div class="user-profiles">
          <div class="user" *ngFor="let user of params.data.assignees">
            <img
              *ngIf="user?.profilepicture"
              [src]="user.profilepicture"
              class="user-avatar"
            />
            <div *ngIf="!user?.profilepicture" class="user-avatar user-avatar-initials">{{ getInitials(user?.username) }}</div>
            <span class="user-name">{{ user?.username }}</span>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #noData>
        <img
            [src]="fallbackImage"
            class="user-avatar"
        />
      <span class="space-between-img">Unassigned</span>
    </ng-template>
  `,
    styles: [`
    .user-profiles {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .user {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .user-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      object-fit: cover;
    }
    .user-avatar-initials {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #F2994A;
      color: #fff;
      font-size: 10px;
      font-weight: 700;
    }
    .user-name {
      font-size: 13px;
    }
    .space-between-img {
        padding-left: 4px;
    }
    app-user-icon-list {
        height: 40px;
        display: flex;
        align-items: center;
        margin-left: 6px;
    }
  `]
})
export class CsAgGridCustomUserRendererComponent implements ICellRendererAngularComp {
    public params: any;
    public assignees: any[] = [];
    public fallbackImage: string = 'images/profile_avatar_small.jpg';

    agInit(params: any): void {
        this.params = params;
    }

    refresh(params: any): boolean {
        this.params = params;
        return true;
    }

    getInitials(name: string): string {
        if (!name) {
            return '';
        }
        return name
            .split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2);
    }
}





